import { Action } from '@ngrx/store';
import { EncFile, ErrCode, PathListApiOutput } from '../shared/models';
import { PathListApiInput } from '../shared/models/api';
import { FileItem } from '../shared/models/files.model';
export const FILE_LIST_RESET = '[FileList] Reset';
export const FILE_LIST_REFRESH = '[FileList] Refresh';
export const FILE_LIST_RELOAD = '[FileList] Reload';
export const FILE_LIST_ERROR = '[FileList] Error';
export const FILE_LIST_SUCCESS = '[FileList] Success';
export const FILE_LIST_SORT = '[FileList] Sort';
export const FILE_LIST_SELECT = '[FileList] Select';
export const FILE_LIST_SELECT_ALL = '[FileList] Select all';
export const FILE_LIST_SELECT_TOGGLE = '[FileList] Select toggle';
export const FILE_LIST_SELECT_TYPE = '[FileList] Select by type';
export const FILE_LIST_SET_CWD = '[FileList] Set cwd';
export const FILE_LIST_SET_PARENTS = '[FileList] Set parents';
export const FILE_LIST_SET_HIST_ID = '[FileList] Set hist_id';
export const FILE_LIST_SET_PROGRESS = '[FileList] Set progress';
export const FILE_LIST_UPDATE = '[FileList] Update file list state';
export const FILE_LIST_SHOW_DELETED = '[FileList] Show deleted';
export const FILE_LIST_SHOW_FAVORITES = '[FileList] Show favorites';
export const FILE_LIST_TOTAL_FAVORITE = '[FileList] Total favorite';
export const FILE_LIST_SET_THUMBNAILS = '[File List] Set Thumbnails';
export const FILE_LIST_FILTER = '[File List] Filter';
export const FILE_LIST_UPDATE_STARRED = '[File List] Update Starred';
export const FILE_LIST_SET_PATHLIST = '[FileList] Set pathlist';
export const FILE_LIST_INSERT_COPY_PLACEHOLDERS = '[File List] Insert Copy Placeholders';
export const FILE_LIST_DELETE_COPY_PLACEHOLDERS = '[File List] Delete Copy Placeholders';

export class FileListResetAction implements Action {
    readonly type = FILE_LIST_RESET;
    constructor() {}
}
export class FileListSuccessAction implements Action {
    readonly type = FILE_LIST_SUCCESS;
    constructor(public payload: FileItem[], public sort=true) {}
}
export class FileListSetCwdAction implements Action {
    readonly type = FILE_LIST_SET_CWD;
    constructor(public payload: FileItem) {}
}
export class FileListSetParentsAction implements Action {
    readonly type = FILE_LIST_SET_PARENTS;
    constructor(public payload: EncFile[]) {}
}
export class FileListSetProgressAction implements Action {
    readonly type = FILE_LIST_SET_PROGRESS;
    constructor(public payload: number) {}
}
export class FileListSetHistIdAction implements Action {
    readonly type = FILE_LIST_SET_HIST_ID;
    constructor(public payload: number) {}
}
export class FileListShowDeletedAction implements Action {
    readonly type = FILE_LIST_SHOW_DELETED;
    constructor() {}
}
export class FileListShowFavoritesAction implements Action {
    readonly type = FILE_LIST_SHOW_FAVORITES;
    constructor(public payload: {syncId: number}) {}
}
export class FileListRefreshAction implements Action {
    readonly type = FILE_LIST_REFRESH;
    constructor(public payload: PathListApiInput) {}
}
export class FileListReloadAction implements Action {
    readonly type = FILE_LIST_RELOAD;
    constructor() {}
}

export class FileListErrorAction implements Action {
    readonly type = FILE_LIST_ERROR;
    constructor(public payload: ErrCode) {}
}

export class FileListSortAction implements Action {
    readonly type = FILE_LIST_SORT;
    constructor(public payload: any) {}
}

export class FileListSelectAction implements Action {
    readonly type = FILE_LIST_SELECT;
    constructor(public payload: FileItem) {}
}

export class FileListSelectAllAction implements Action {
    readonly type = FILE_LIST_SELECT_ALL;
    constructor(public payload: any) {}
}
export class FileListSelectToggleAction implements Action {
    readonly type = FILE_LIST_SELECT_TOGGLE;
    constructor(public payload: FileItem) {}
}
export class FileListSelectTypeAction implements Action {
    readonly type = FILE_LIST_SELECT_TYPE;
    constructor(public payload: any) {}
}
export class FileListTotalFavoriteAction implements Action {
    readonly type = FILE_LIST_TOTAL_FAVORITE;
    constructor(public payload: any) {}
}

export class SetThumbnails implements Action {
    readonly type = FILE_LIST_SET_THUMBNAILS;
    constructor(public payload: { thumbnails: FileItem[] }) {}
}

export class FilterListAction implements Action {
    readonly type = FILE_LIST_FILTER;
    constructor(public payload: { searchValue: string }) { }
}

export class UpdateStarred implements Action {
    readonly type = FILE_LIST_UPDATE_STARRED;
    constructor(public payload: {[key: number]: boolean}) {}
}

export class FileListSetPathlistAction implements Action {
    readonly type = FILE_LIST_SET_PATHLIST;
    constructor(public payload: FileItem[]) {}
}
export class InsertCopyPlaceholders implements Action {
    readonly type = FILE_LIST_INSERT_COPY_PLACEHOLDERS;
    constructor(public payload: { fileIds: number[] }) {}
}

export class DeleteCopyPlaceholders implements Action {
    readonly type = FILE_LIST_DELETE_COPY_PLACEHOLDERS;
    constructor() {}
}

export class FileListUpdateAction implements Action {
    readonly type = FILE_LIST_UPDATE;
    constructor(public payload: Partial<PathListApiOutput>) {}
}

export type All = FileListResetAction
    | FileListRefreshAction
    | FileListReloadAction
    | FileListSetProgressAction
    | FileListShowDeletedAction
    | FileListShowFavoritesAction
    | FileListSetCwdAction
    | FileListSetHistIdAction
    | FileListSetParentsAction
    | FileListSuccessAction
    | FileListErrorAction
    | FileListSortAction
    | FileListSelectAction
    | FileListSelectAllAction
    | FileListSelectToggleAction
    | FileListSelectTypeAction
    | FileListTotalFavoriteAction
    | SetThumbnails
    | FilterListAction
    | UpdateStarred
    | FileListSetPathlistAction
    | InsertCopyPlaceholders
    | DeleteCopyPlaceholders 
    | FileListUpdateAction;